import React from "react";
import "../styles/Order.css";

const whatsappLink = "https://wa.me/message/X6KLKUUKNBGJE1";

const products = [
  {
    title: "Electronics",
    image:
      "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800",
    description:
      "Smartphones, laptops, tablets, smart TVs, accessories, gaming devices, and many more electronic products sourced directly from trusted manufacturers in China.",
  },
  {
    title: "Shoes & Footwear",
    image:
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800",
    description:
      "Wholesale sports shoes, casual footwear, leather shoes, sandals, children's shoes, and customized footwear for businesses.",
  },
  {
    title: "Cars & Auto Parts",
    image:
      "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800",
    description:
      "Automobiles, motorcycles, spare parts, batteries, tires, car accessories, and high-quality automotive equipment.",
  },
  {
    title: "Beauty & Cosmetics",
    image:
      "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800",
    description:
      "Beauty products, skincare, makeup, perfumes, hair care, salon equipment, and cosmetic accessories for wholesale orders.",
  },
  {
    title: "Clothing & Textiles",
    image:
      "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=800",
    description:
      "Men's, women's, and children's clothing, uniforms, fabrics, fashion accessories, and textile products for bulk purchasing.",
  },
  {
    title: "Industrial Machinery",
    image:
      "https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=800",
    description:
      "Industrial machines, construction equipment, manufacturing tools, agricultural machinery, and heavy-duty equipment.",
  },
];

const Order = () => {
  return (
    <section className="order-page">

      <div className="order-header">
        <h1>Bulk Order Products</h1>

        <p>
          Source premium-quality products directly from China with competitive
          pricing, reliable suppliers, and worldwide shipping solutions.
        </p>
      </div>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.title} />

            <div className="card-content">
              <h2>{product.title}</h2>

              <p>{product.description}</p>

              <button
                onClick={() =>
                  window.open(whatsappLink, "_blank", "noopener,noreferrer")
                }
              >
                Request Quote
              </button>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
};

export default Order;